module.exports = __webpack_public_path__ + "images/741072da8d95482e68bbeb5d59048d8e.png";